module.exports = __webpack_public_path__ + "img/portfolio-details2.0603eacf.png";